export const DATE_TIME_FORMAT = "lll"; // Apr 23, 2020 1:38 PM
export const CLR_BTN = "teal darken-3";
export const CLR_LEFT_NAV = "grey darken-4";
export const CLR_FOOTER = "teal darken-3";
export const CLR_OVERLAY = "#bec5b7";
export const SEPARATOR = "~~";
export const NB_LOGO = "https://res.cloudinary.com/lexcom/image/upload/v1597277128/northbattleford_logo_d599306ecb.png";
